import { ColDef } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { AgGridColumnType, AgGridExportType, ExportedColDef } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import IncidentRenderer from '@/cellRenderers/common/IncidentRenderer.vue'
import AttachmentCountRenderer from '@/cellRenderers/common/AttachmentCountRenderer.vue'

export const shipmentsGridPendingToSendColumnDefs: (ColDef | ExportedColDef)[] = [
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('shipments.grid.elementNumber'),
        field: 'entityLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        minWidth: 80
    },
    {
        headerName: i18n.tc('shipments.grid.element'),
        field: 'entityType',
        type: AgGridColumnType.SHIPMENT_CORE_ENTITY,
        exportField: 'entityType.translatedName',
        exportType: AgGridExportType.TEXT,
        minWidth: 120
    },
    {
        headerName: i18n.tc('shipments.grid.sampleType'),
        colId: 'sample.sampleType.description',
        field: 'sample.sampleType',
        type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
        exportField: 'sample.sampleType.description',
        exportType: AgGridExportType.TEXT,
        cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : '',
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.location'),
        colId: 'sample.topographicCode.description',
        field: 'sample.topographicCode',
        type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING,
        exportField: 'sample.topographicCode.description',
        exportType: AgGridExportType.TEXT,
        cellRenderer: ({ value }: ICellRendererParams) => value ? `${value.code} | ${value.description}` : '',
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.assay'),
        field: 'subportion.assay.name',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.status'),
        field: 'status',
        type: AgGridColumnType.SHIPMENT_REQUEST_STATUS,
        exportField: 'status.translatedName',
        exportType: AgGridExportType.TEXT,
        minWidth: 180,
        filter: false,
        sortable: false
    },
    {
        headerName: i18n.tc('shipments.grid.propietaryCenter'),
        colId: 'caseStudy.laboratory.labName',
        field: 'ownerLaboratory.labName',
        type: AgGridColumnType.LABORATORIES,
        exportType: AgGridExportType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.destinationCenter'),
        field: 'destinationLaboratory.labName',
        type: AgGridColumnType.LABORATORIES,
        exportType: AgGridExportType.TEXT,
        minWidth: 180
    },
    {
        headerName: i18n.tc('shipments.grid.pathologist'),
        colId: 'caseStudy.pathologist.normalizedFullName',
        field: 'pathologist.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        minWidth: 180,
        flex: 1
    },
    {
        headerName: i18n.tc('grid.hasAlarms'),
        headerTooltip: i18n.tc('grid.hasAlarms'),
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-exclamation-triangle')
        },
        field: 'incidentsCount',
        type: AgGridColumnType.INCIDENT,
        exportType: AgGridExportType.INTEGER,
        cellRendererFramework: IncidentRenderer,
        sortable: false,
        filter: false,
        hide: false,
        maxWidth: 80
    },
    {
        headerName: i18n.tc('grid.attachments'),
        headerTooltip: i18n.tc('grid.attachments'),
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-paperclip')
        },
        field: 'attachmentsCount',
        type: AgGridColumnType.ATTACHMENT_COUNT,
        exportType: AgGridExportType.INTEGER,
        cellRendererFramework: AttachmentCountRenderer,
        sortable: false,
        filter: false,
        hide: false,
        maxWidth: 80
    }
]
